//categories used in budgets and expenses
export const DEFAULT_CATEGORIES = [
    'Housing',
    'Food',
    'Utilities',
    'Transportation',
    'Savings & Investments',
    'Debt Payments',
    'Health & Personal Care',
    'Entertainment & Leisure',
    'Insurance',
    'Other',
  ];

// Backward-compat alias
export const CATEGORIES = DEFAULT_CATEGORIES;
